export default class NumberUtils {
  static isNumber(num: number | undefined | null): num is number {
    return typeof num === "number" && !isNaN(num) && isFinite(num);
  }

  static roundTo2Digits(num: number): number {
    return this.roundHalfUp(num, 2);
  }

  static roundTo4Digits(num: number): number {
    return this.roundHalfUp(num, 4);
  }

  static roundHalfUp(num: number, scale: number): number {
    const factor = 10 ** scale;
    const sign = num < 0 ? -1 : 1;
    return (sign * Math.round((Math.abs(num) + Number.EPSILON) * factor)) / factor;
  }
}
